module.exports = __webpack_public_path__ + "img/exp-date.f11077ea.svg";